export default {
  // 船司账号维护
  account: {
    title: '船司账号维护',
    filters: {
      accountName: '账号名称',
      accountNamePlaceholder: '请输入',
      carrier: '船司/平台',
      carrierPlaceholder: '全部',
      status: '状态',
      statusPlaceholder: '全部',
      search: '查询',
      reset: '重置',
      add: '新增账号'
    },
    columns: {
      accountName: '账号名称',
      carrier: '船司/平台',
      platformType: '平台类型',
      usage: '用途',
      loginAccount: '登录账号',
      status: '状态',
      maintainer: '维护人',
      updatedAt: '更新时间',
      actions: '操作'
    },
    platformTypes: {
      official: '承运人官网',
      thirdParty: '第三方平台',
      internal: '内部接口'
    },
    usages: {
      query: '查价',
      booking: '订舱'
    },
    statusLabels: {
      enabled: '启用',
      disabled: '停用'
    },
    deleteConfirm: '确定删除该账号吗？',
    messages: {
      loadSuccess: '账号加载完成',
      loadFailed: '加载账号列表失败',
      createSuccess: '账号新增成功',
      createFailed: '新增失败',
      updateSuccess: '账号修改成功',
      updateFailed: '修改失败',
      deleteSuccess: '账号已删除',
      toggleSuccess: '{name} 已{status}'
    },
    // 弹窗
    modal: {
      create: '新增账号',
      edit: '编辑账号',
      company: '所属公司',
      companyPlaceholder: '默认当前账号所在分公司',
      carrierPlaceholder: '选择关联船司（可选）',
      usageLabel: '账号用途',
      enabledLabel: '启用状态',
      enabledText: '启用',
      disabledText: '停用',
      loginAccount: '登录账号',
      loginAccountRequired: '请输入登录账号',
      loginPassword: '登录密码',
      loginPasswordRequired: '请输入登录密码',
      loginPasswordEditPlaceholder: '留空表示不修改密码',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      securityTip: '当前仅为原型展示，真实账号密码需加密存储，并由后台统一进行权限与安全管理。'
    }
  },

  // 今日运价
  daily: {
    title: '今日运价',
    exportFilename: '今日电商运价',
    exportTitle: '今日电商运价',
    filters: {
      pol: '起运港',
      pod: '目的港',
      containerType: '箱型',
      carrier: '船公司',
      etd: 'ETD'
    },
    actions: {
      subscriptionConfig: '每日推送配置',
      manualRefresh: '手动刷新',
      exportExcel: '导出 Excel',
      search: '查询',
      reset: '重置'
    },
    columns: {
      pol: '起运港',
      pod: '目的港',
      carrier: '船公司',
      containerType: '箱型',
      basePrice: '基价',
      totalPrice: '总价',
      currency: '币种',
      etd: 'ETD',
      eta: 'ETA',
      transitDays: '航程(天)',
      vesselName: '船名',
      voyage: '航次',
      routeCode: '航线',
      spaceStatus: '舱位',
      isDirect: '直达',
      rateUpdatedAt: '价格更新时间'
    },
    spaceStatus: {
      available: '现舱',
      soldOut: '售罄',
      unavailable: '不可订'
    },
    directStatus: {
      direct: '直达',
      transit: '中转'
    },
    messages: {
      loadFailed: '加载今日运价失败',
      refreshSuccess: '刷新成功',
      exportSuccess: '导出成功',
      noDataToExport: '无数据可导出',
      exportFailed: '导出失败'
    },
    exportDrawer: {
      title: '导出今日运价',
      subtitle: '选择推送时使用的导出模板。平台提供标准模板，也支持自定义。',
      defaultTemplatesTitle: '平台默认模板',
      customTemplatesTitle: '自定义模板',
      coreTemplateName: '标准模板（核心字段）',
      coreTemplateDesc: '起运港、目的港、箱型、船公司、40GP价格、40HQ价格、ETD、ETA',
      fullTemplateName: '标准模板（全量字段）',
      fullTemplateDesc: '含核心字段 + 运价号、货物类型、20GP/45HC/冷冻柜价格、直达标志、免用箱、免堆存、有效期等',
      usLineTemplateName: '美线专用模板',
      usLineTemplateDesc: '适用于美线航线推送，含美西/美东港口',
      europeLineTemplateName: '欧洲线详细模板',
      europeLineTemplateDesc: '欧洲航线全套字段，含中转港信息',
      salesBriefTemplateName: '销售简报模板',
      salesBriefTemplateDesc: '精简字段，适合销售团队快速浏览',
      fieldsCount: '{count} 个字段',
      excelExport: 'Excel 导出',
      rateExport: '电商运价',
      defaultLabel: '默认',
      confirmExport: '确认导出',
      messages: {
        exportSuccess: '导出成功',
        noData: '没有可导出的数据',
        exportFailed: '导出失败'
      }
    }
  },

  // 每日推送配置
  subscription: {
    title: '每日推送配置',
    pushConfig: {
      title: '推送配置（全局）',
      pushTimeTitle: '⏰ 推送时间',
      pushTimeEarly: '早上推送',
      pushTimeLate: '傍晚推送',
      channelEmail: '📧 邮件',
      channelHttp: '🔌 HTTP 接口',
      channelPage: '👁️ 仅页面查看',
      emailTitle: '邮件推送',
      emailEnabled: '已启用',
      receiveEmails: '接收邮箱',
      emailInputPlaceholder: '输入邮箱，回车添加',
      httpTitle: 'HTTP 接口推送',
      httpEnabled: '平台开通',
      httpEndpoint: 'HTTP 端点',
      httpSecret: '密钥',
      pageTitle: '仅页面查看',
      pageDesc: '每日运价只保留在系统中，可前往「今日运价」查看和导出。',
      saveSuccess: '推送配置已保存',
      saveFailed: '保存失败'
    },
    templateConfig: {
      title: '模板配置（全局）',
      subtitle: '选择及拖拽排序推送时使用的导出字段模板。平台提供核心字段，也支持自定义。',
      defaultTemplatesTitle: '平台默认模板',
      customFieldsTitle: '自定义字段顺序与开关',
      coreTemplateName: '标准模板（核心字段）',
      fullTemplateName: '标准模板（全量字段）',
      coreTemplateDesc: '起运港、目的港、箱型、船公司、基价、总价、ETD、ETA',
      fullTemplateDesc: '含核心字段 + 航线代码、船名航次、是否直达、舱位状态、价格更新时间等',
      fieldsCount: '{count} 个字段',
      excelExport: 'Excel 导出',
      defaultLabel: '默认',
      selectedCount: '已选择 {selected} / {total} 个字段',
      selectAll: '全选',
      clearAll: '清空',
      cancel: '取消',
      save: '保存',
      saveSuccess: '模板配置已保存',
      saveFailed: '保存失败',
      fields: {
        scheduleId: '船期ID',
        freightId: '运价ID',
        carrierCode: '船公司',
        vesselName: '船名',
        voyage: '航次',
        routeCode: '航线代码',
        polCode: '起运港代码',
        podCode: '目的港代码',
        etd: 'ETD',
        eta: 'ETA',
        transitDays: '航程天数',
        isDirect: '是否直达',
        containerType: '箱型',
        spaceStatus: '舱位状态',
        basePrice: '基价',
        totalPrice: '总价',
        currency: '币种',
        rateUpdatedAt: '价格更新时间',
        productDetailId: '商品明细ID'
      }
    },
    batchAdd: {
      title: '批量新增配置',
      alertContent: '多选后自动组合。唯一键：租户+起运港+目的港。',
      polLabel: '起运港（可多选）',
      podLabel: '目的港（可多选）',
      containerTypeLabel: '箱型（可多选）',
      carrierLabel: '船公司（可多选）',
      polPlaceholder: '选择起运港',
      podPlaceholder: '选择目的港',
      containerTypePlaceholder: '全部箱型',
      carrierPlaceholder: '全部船公司',
      batchCreateSuccess: '批量新增成功，共{count}条'
    },
    actions: {
      add: '新增配置',
      batchAdd: '批量新增',
      edit: '编辑配置',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      pushConfig: '推送配置',
      templateConfig: '模板配置',
      import: '批量导入',
      downloadTemplate: '下载批量导入模板',
      parse: '识别并解析',
      parsing: '正在识别并解析...',
      prevStep: '上一步',
      nextStep: '下一步',
      confirmImport: '确认导入',
      selectPol: '选择起运港',
      selectPod: '选择目的港'
    },
    filters: {
      pol: '起运港',
      pod: '目的港',
      carrier: '船公司'
    },
    columns: {
      pol: '起运港',
      pod: '目的港',
      carrier: '船公司',
      containerType: '箱型',
      frequency: '推送频率',
      notifyChannels: '推送渠道',
      status: '状态',
      lastPushTime: '最近推送',
      actions: '操作',
      dateCreated: '创建时间',
      fieldName: '字段名',
      isRequired: '是否必填',
      description: '说明'
    },
    labels: {
      all: '全部',
      pol: '起运港',
      pod: '目的港',
      containerTypeSelect: '箱型（可多选）',
      containerTypeAll: '全部箱型',
      carrierSelect: '船公司（可多选）',
      carrierAll: '全部船公司',
      deleteConfirm: '确定删除？',
      importConfig: '批量导入配置',
      stepImport: '模板与导入',
      stepConfirm: '确认导入',
      importTitle: '模板与导入功能',
      importDesc: '可下载标准模板后批量导入数据，系统将自动解析并生成推送配置。支持 .xlsx, .xls 格式。',
      dragUploadTip: '点击或拖拽文件到此处上传',
      fileFormatLimit: '支持 .xlsx, .xls，文件大小不超过 10MB',
      parseSuccess: '解析成功，共识别 {count} 条数据',
      fieldDescTable: '模板字段说明',
      required: '必填',
      notRequired: '非必填',
      totalCount: '总条数',
      creatable: '可创建',
      failed: '失败',
      errorReason: '说明/错误原因'
    },
    tplFields: {
      polDesc: '港口代码，如 CNSHA',
      podDesc: '港口代码，如 DEHAM',
      carrierDesc: '承运人代码，如 MSC',
      containerTypeDesc: '如 20GP/40GP/40HQ'
    },
    frequency: {
      daily: '每日',
      weekly: '每周',
      realtime: '实时'
    },
    statusLabels: {
      active: '启用',
      paused: '暂停'
    },
    notifyChannels: {
      email: '邮件',
      system: '系统消息'
    },
    messages: {
      loadFailed: '加载订阅失败',
      createSuccess: '新增订阅成功',
      updateSuccess: '更新订阅成功',
      deleteSuccess: '删除订阅成功',
      saveSuccess: '保存成功',
      saveFailed: '提交失败',
      deleteFailed: '删除失败',
      importSuccess: '导入成功！',
      importFailed: '导入失败',
      polPodRequired: '请选择起运港和目的港',
      downloadSuccess: '模板下载成功',
      downloadFailed: '模板下载失败'
    }
  }
}
